module.exports = __webpack_public_path__ + "static/media/TaiXiumini.434adba0.png";